exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".json-item{width:100%;height:100%}.json-item.string-box{height:auto;line-height:20px;overflow:hidden;word-break:break-all}.json-item .number{color:#2fa0ed}.json-item .string{color:#f16222}.json-item .boolean{color:#00c099}.json-item .null{color:#c3c}.json-item .key{color:#424456}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77986a1e","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/hll-json-box.vue
// module id = 824
// module chunks = 0